import { useState } from "react";
import { Link } from "react-router-dom";
import { FaStore } from "react-icons/fa";
import Modal from "../Modal";
import styles from "./Footer.module.css";

const POLICY_TEXT = `沃克貓工作室 網路商店服務條款
https://shop.workat.com.tw

沃克貓工作室係依據本條款提供「https://shop.workat.com.tw」網路商店服務（以下簡稱本網站）。敬請仔細閱讀本約定書的內容，本網站之交易均受本約定書之規範，當您使用本網站進行交易時，即表示您已閱讀、瞭解並同意接受本約定書所有內容，同時您也已同意以電子文件做為意思表示之方法。本約定書之內容可能隨時修改，如果您於任何修改或變更後繼續使用本網站，視為您已閱讀、瞭解並同意接受該等修改或變更。因此敬請您每次使用本網站進行交易之前，均再一次詳讀本約定書之內容，如果您不同意本約定書內容，或您所屬的國家或地域排除本約定書內容之全部或一部時，您應立即停止使用本網站。
若您未滿二十歲，除應符合上述規定外，並應與您的家長（或監護人）一同閱讀、瞭解並同意本約定書之所有內容及其後之任何修改或變更。

【訂購須知】
預訂時間：本店販售各式商品，依商品性質不同，部分商品採接單後製作，請於提貨日（配送日）前確認所需備貨時間，詳見各商品說明頁。
商品依實際狀況為主：商品價格、規格或外觀若有變動，恕不另行通知，以網站公告為主。
訂單確認：如訂購資料不完整或無法與訂購本人確認，此訂單將會暫不受理。
請當場查驗商品：請於收貨時即時驗收品質，若產品有瑕疵或其他問題，可當下拒收且拍照存證，以保障自身權益，並立即與本店聯絡。

【訂單付款與運送】
本網站可能更新商品資訊或調整售價，請您在下單前務必確認清楚。
當您以信用卡支付商品價款時，必須輸入有效的信用卡號（目前接受 VISA、Master 與 JCB）。本網站將與發卡銀行系統連繫，以確認信用卡的有效性，並在確認成功授權後，發出確認電子郵件通知您。
運送方式：商品透過貨運／宅配運送。若經配送兩次無法送達，且再經本公司以電話或 E-mail 均無法聯繫逾三天者，本網站將取消該筆訂單，並由專人與您聯繫進行退貨／退款處理。
運送範圍：台灣本島、外島（金門、澎湖）。收件地址請勿填寫郵政信箱。若單筆訂單折扣後合計金額達到免運費優惠資格，當筆訂單即可享有免費運送服務，不足時將加收運送服務費。

【商品包裝】
本網站所銷售的商品皆不提供代客換裝的服務。

【退貨處理】
商品退換貨須符合以下規定：商品必須為全新狀態且完整包裝（包含商品本體、內外包裝、發票）。若商品有品質瑕疵問題，本公司無條件退換。請您務必謹慎下單，確認所需商品後再行結帳。

【商品資訊】
本約定書未規範之事宜，請詳見相關事項及個別商品之網頁說明及其他服務說明。

【系統安全】
本網站與您交易所使用之電腦系統，確保具有符合一般可合理期待之安全性。

【系統中斷或故障】
本網站倘若出現中斷或故障等現象，或許將造成您使用上的不便、資料喪失、錯誤或其他損失，本網站將全力維護您的交易安全，並提醒您於使用本網站時，採取更多的防護措施以增益交易安全性。

【個人資料保護】
本網站將依照個人資料保護法令相關規定保護您的個人資料。

【帳號密碼被冒用之處理】
本網站於知悉您的帳號密碼遭冒用時，將立即停止該帳號所生交易之處理及後續利用。

【消費爭議處理】
您所訂購的所有商品，其品質、數量等事項，可與本網站客服人員聯絡，本網站將協助您解決相關問題。

【準據法與管轄法院】
本約定書之解釋與適用，以及與本約定書有關的爭議，均依照中華民國法律予以處理。本合約條款如有疑義時，應為有利於消費者之解釋。


沃克貓工作室
統一編號：85426409
網址：https://shop.workat.com.tw`;

function Footer() {
  const [policyOpen, setPolicyOpen] = useState(false);

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <div className={styles.logo}>
            <FaStore />
            <span>沃克貓購物網</span>
          </div>
          <p className={styles.desc}>
            精選商品，優質購物體驗。
            <br/>
            沃克貓工作室 85426409
          </p>
          <button
            className={styles.policyBtn}
            onClick={() => setPolicyOpen(true)}
            aria-label="查看隱私權與退換貨政策"
          >
            隱私權與退換貨政策
          </button>
        </div>

        <nav className={styles.links} aria-label="頁腳導覽">
          <h4 className={styles.linkTitle}>快速連結</h4>
          <Link to="/">首頁</Link>
          <Link to="/products">所有商品</Link>
          <Link to="/cart">購物車</Link>
          <Link to="/orders">訂單紀錄</Link>
        </nav>
      </div>

      <div className={styles.copy}>
        © {new Date().getFullYear()} 沃克貓購物網. All rights reserved.
      </div>

      {policyOpen && (
        <Modal title="隱私權與退換貨政策" onClose={() => setPolicyOpen(false)}>
          {POLICY_TEXT}
        </Modal>
      )}
    </footer>
  );
}

export default Footer;
